import { Link, useLocation } from "react-router-dom";
import SegmentMenu from "../../../../../../components/navegation/SegmentMenu";
import { Fragment, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setSegments,
  clearSegments,
} from "../../../../../../store/redux_auth/authSlice";
import { getLanguageContent } from "../../../../../../utils/language/languageSelector";
import { PERSONAL_FINANCES_SCHEMA } from "../../../../../../utils/schemas/language/pages/personalFinancesSchema";

function PersonalFinancesMenu({
  isLoading = false,
  onOpenInstitutions,
  onOpenUpgrade,
}) {
  const [isUpgradeHovered, setIsUpgradeHovered] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const content = getLanguageContent(PERSONAL_FINANCES_SCHEMA);
  const navContent = content.navigation;
  const segmentTextByKey = navContent.segments.reduce((acc, segment) => {
    acc[segment.key] = segment.text;
    return acc;
  }, {});

  const financialInsightsState = useSelector(
    (state) => state.auth.user?.financial_insights,
  );
  const isMaxPlan = financialInsightsState?.is_max_plan;

  const financeSegments = useMemo(
    () => [
      {
        path: "/finances/personal-finances/overview",
        text: segmentTextByKey.overview,
        normalIcon: `${process.env.PUBLIC_URL}/images/icons/overview_grey.svg`,
        activeIcon: `${process.env.PUBLIC_URL}/images/icons/overview_blue.svg`,
      },
      {
        path: "/finances/personal-finances/transactions",
        text: segmentTextByKey.transactions,
        normalIcon: `${process.env.PUBLIC_URL}/images/icons/transactions_grey.svg`,
        activeIcon: `${process.env.PUBLIC_URL}/images/icons/transactions_blue.svg`,
      },
      {
        path: "/finances/personal-finances/recurring-transactions",
        text: segmentTextByKey.recurring,
        normalIcon: `${process.env.PUBLIC_URL}/images/icons/recurring_transaction_grey.svg`,
        activeIcon: `${process.env.PUBLIC_URL}/images/icons/recurring_transaction_blue.svg`,
      },
      {
        path: "/finances/personal-finances/budgets",
        text: segmentTextByKey.budgeting,
        normalIcon: `${process.env.PUBLIC_URL}/images/icons/budgeting_grey.svg`,
        activeIcon: `${process.env.PUBLIC_URL}/images/icons/budgeting_blue.svg`,
      },
      {
        path: "/finances/personal-finances/spendings",
        text: segmentTextByKey.spendings,
        normalIcon: `${process.env.PUBLIC_URL}/images/icons/spendings_grey.svg`,
        activeIcon: `${process.env.PUBLIC_URL}/images/icons/spendings_blue.svg`,
      },
      {
        path: "/finances/personal-finances/income",
        text: segmentTextByKey.income || "Income",
        normalIcon: `${process.env.PUBLIC_URL}/images/icons/spendings_grey.svg`,
        activeIcon: `${process.env.PUBLIC_URL}/images/icons/spendings_blue.svg`,
      },
    ],
    [segmentTextByKey],
  );

  // 2. Manage Segments Teleport Lifecycle
  useEffect(() => {
    dispatch(setSegments(financeSegments));
    return () => dispatch(clearSegments());
  }, [dispatch, financeSegments]);

  const params = new URLSearchParams(location.search);
  const first = params.toString().split("&")[0];
  const currentSegment = first
    ? `${location.pathname}?${first}`
    : location.pathname;

  return (
    <Fragment>
      <SegmentMenu
        loading={isLoading}
        segments={financeSegments}
        currentPath={currentSegment}
        hideForMobile={true}
        cta={
          <div className="segment-menu-cta-container">
            {/* HOIST SYNCED ACTION: Triggers the parent's layout state engine directly on click */}
            <Link
              className="cta-button primary rounded"
              onClick={(e) => {
                e.preventDefault();
                if (onOpenInstitutions) onOpenInstitutions();
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/icons/institutions_white.svg`}
                alt={navContent.institutions.image_alt}
                className="sidebar-icon"
              />
              {navContent.institutions.text}
            </Link>
            {!isMaxPlan && (
              <Link
                className="cta-button secondary rounded"
                onClick={(e) => {
                  e.preventDefault();
                  if (onOpenUpgrade) onOpenUpgrade();
                }}
                onMouseEnter={() => setIsUpgradeHovered(true)}
                onMouseLeave={() => setIsUpgradeHovered(false)}
              >
                <img
                  src={
                    isUpgradeHovered
                      ? `${process.env.PUBLIC_URL}/images/icons/upgrade_plan_white.svg`
                      : `${process.env.PUBLIC_URL}/images/icons/upgrade_plan_blue.svg`
                  }
                  alt={navContent.upgrade_plan.image_alt}
                  className="sidebar-icon"
                />
                {navContent.upgrade_plan.text}
              </Link>
            )}
          </div>
        }
        ctaGhostCount={1}
      />
    </Fragment>
  );
}

export default PersonalFinancesMenu;
